import * as React from "react";
import * as pc from 'playcanvas';
import * as PlayCanvasHelper from './helpers/PlayCanvasHelper';
import GetBrowserInfo from './helpers/GetBrowserInfo';

declare const window: any;
window.pc = pc; //arreglo simple para que reconozca 'pc' en los scripts de playcanvas

const browserInfo: any = GetBrowserInfo();
const paramQuality = browserInfo.urlParams.get('quality');
const paramProfiler = browserInfo.urlParams.get('profiler');
const paramFrame = browserInfo.urlParams.get('showframe');

//Valos obtenido de la cámara de MAX.
const defaultFOV = 37;

const showHoverMesh = false;
const showClickedMesh = false;
const showCameraPosition = false;
const awsRootPath = "https://d1bsymnertnea6.cloudfront.net/";
const isRunningLocally = ['localhost', '127.0.0.1', '192.168.1.7'].includes(window.location.hostname) === true;

const defaultLayoutOpacity = 0.60;
const defaultLayoutBorderOpacity = 0.95;
const defaultSafariLayoutOpacity = 0.20;
const defaultSafariLayoutBorderOpacity = 0.95;

type Props = {
  spinDiv: HTMLDivElement;
  frame: any;
  data: any;

  menuSelected: string;
  subMenuSelected: string;
  hotspotsSelected: any;
  isSelectedAmenities: string;

  isSelectedAttribute: any;
  selectAvailability: any;

  introView: any;
  isSelectedTownplanning: string;

  originalWidth: number;
  originalHeight: number;
  isSideBarAsoleacion: boolean;


  isSelectedApto: any;
  isSelectedAptoView: any;
  showTextHotspots: boolean;
  setIsSelectedApto: (value: any) => void;
  OnDetailsClicked: (hotspotID: string) => void;
  setIsSelectedAmenities: (id: string) => void;

  spinFocused: React.RefObject<boolean>;
}

const SpinsEngine: React.FC<Props> = ({ spinDiv, frame, data, menuSelected, subMenuSelected, isSelectedAmenities, isSelectedAttribute, selectAvailability, spinFocused, introView, isSelectedTownplanning, hotspotsSelected, isSelectedApto, showTextHotspots, originalWidth, originalHeight, isSideBarAsoleacion, isSelectedAptoView, setIsSelectedApto, OnDetailsClicked, setIsSelectedAmenities}) => {

  const [sceneReady, setSceneReady] = React.useState(false);
  const [isVisible, setIsVisible] = React.useState(false);
  const [isConstantWidth, setIsConstantWidth] = React.useState(true);
  const [isPortrait, setIsPortrait] = React.useState(false);
  const [showCurrentFrame, setShowCurrentFrame] = React.useState(false);

  const containerRef = React.useRef<HTMLDivElement>(null);
  const canvasRef = React.useRef<HTMLCanvasElement>(null);
  const appRef = React.useRef<pc.Application|null>(null);
  const cameraEntityRef = React.useRef<pc.Entity>(null);
  const rootEntityRef = React.useRef<pc.Entity|null>(null);
  const masterplanEntityRef = React.useRef<pc.Entity|null>(null);
  const animComponentRef = React.useRef<pc.AnimComponent|null>(null);
  const detailsHoverRef = React.useRef<boolean>(false);
  const detailsStructRef = React.useRef<any>(null);

  const animFpsRef = React.useRef<number>(30);
  const isPortraitRef = React.useRef(false); //required for PC
  const selectedAptoRef = React.useRef<any>(null); //required for PC

  const isHoveringPropertyRef = React.useRef(false);
  const montserratMediumFontIDRef = React.useRef<number>(-1);

  const cameraCurrentTargetRef = React.useRef<pc.Entity|null>(null);
  const cameraCurrentPositonRef = React.useRef<pc.Entity|null>(null);

  const cameraTargetRef = React.useRef<any>({});
  const cameraPositonRef = React.useRef<any>({});
  const cameraFovRef = React.useRef<any>({});
  
  // const cameraPortraitFOVRef = React.useRef<number>(90);
  // const cameraLandscapeFOVRef = React.useRef<number>(90);

  const amenitiesRef = React.useRef<any>(null);
  const propertiesRef = React.useRef<any>(null);
  const detailsRef = React.useRef<any>(null);
  const townPlanningRef = React.useRef<any>(null);
  const volumesRef = React.useRef<any>(null);

  const propertyByIdRef = React.useRef<any>({});

  const billboardAssetsRef = React.useRef<any>(null);
  const frameCountRef = React.useRef<number>(0);

  const Resize = React.useCallback( () => { //Este TIENE que estar antes de usarse
    //appRef.current?.resizeCanvas();
    PlayCanvasHelper.CustomResize();
    const windowAspect = window.innerWidth / window.innerHeight;
    const portrait = windowAspect < 1;
    const aspect = portrait === true ? 1400 / 2000 : 2000 / 1400;
    setIsConstantWidth(windowAspect > aspect);
    setIsPortrait(windowAspect < 1);
  }, []);

  React.useEffect(() => {
    CreateScene();
    Resize();
    setShowCurrentFrame(paramFrame === "true")
    window.addEventListener('resize', Resize);
    return () => {
      window.removeEventListener('resize', Resize);
      PlayCanvasHelper.DestroyApp();
      //appRef.current?.destroy();
    };
  }, []);

  React.useEffect(() => {
    let visible: boolean = introView === false && sceneReady === true && isSideBarAsoleacion === false && menuSelected !== "Ubicación" && isSelectedAptoView === null;
    if(menuSelected === "Amenidades"){
      visible = (subMenuSelected === "");
    }
    setIsVisible(visible);
    if(sceneReady === true){
      if(visible === true){
        PlayCanvasHelper.ResumeApp();
      }else{
        PlayCanvasHelper.PauseApp();
      }
    }
  }, [introView, sceneReady, isSideBarAsoleacion, menuSelected, subMenuSelected, isSelectedAptoView]);

  React.useEffect(() => {
    //Forzar resize para mobiles principalmente
    Resize();
  }, [introView]);

  React.useEffect(() => {
    if(!spinDiv)
      return;
    
    CanvasExit(); CanvasEnter();

    spinDiv.addEventListener('pointerdown', PointerDown);
    spinDiv.addEventListener('pointermove', PointerMoved);
    spinDiv.addEventListener('mouseenter', CanvasEnter);
    spinDiv.addEventListener('mouseleave', CanvasExit);
    
    return () => {
      spinDiv?.removeEventListener('pointerdown', PointerDown);
      spinDiv?.removeEventListener('pointermove', PointerMoved);
      spinDiv?.removeEventListener('mouseenter', CanvasEnter);
      spinDiv?.removeEventListener('mouseleave', CanvasExit);
    };
  }, [spinDiv]);

  const CanvasEnter = () => {
    if(!spinDiv)
      return;
    //solución temporal, debería ser spinDiv
    appRef.current?.elementInput?.attach(canvasRef.current as any);
    document.body.style.cursor = 'grab';
  }

  const CanvasExit = () => {
    appRef.current?.elementInput?.detach();
    document.body.style.cursor = 'default';
  }

  const PointerMoved = (event: PointerEvent) => {
    if(!containerRef.current || !canvasRef.current || !cameraEntityRef.current || detailsHoverRef.current)// || spinFocused.current === false
      return;

    const containerRect = containerRef.current.getBoundingClientRect();
    const canvasRect = canvasRef.current.getBoundingClientRect();
    let clonedEvent: any = {};
    clonedEvent.clientX = event.clientX + 0.5*(canvasRect.width - containerRect.width);
    clonedEvent.clientY = event.clientY + 0.5*(canvasRect.height - containerRect.height);
    
    const pickedObject = PlayCanvasHelper.GetPickedMesh(clonedEvent, cameraEntityRef.current.camera!);
    if(!pickedObject){
      if(isHoveringPropertyRef.current === true){
        document.body.style.cursor = 'grab';
        isHoveringPropertyRef.current = false;
      }
      return;
    }
    if(showHoverMesh){ console.log(pickedObject.name); }
    if(pickedObject.name.toLocaleLowerCase().includes("property")){
      isHoveringPropertyRef.current = true;
      document.body.style.cursor = 'pointer';
    }else if(isHoveringPropertyRef.current === true){
      isHoveringPropertyRef.current = false;
      document.body.style.cursor = 'grab';
    }
  }

  const PointerDown = (event: PointerEvent) => {
    if(!containerRef.current || !canvasRef.current || !cameraEntityRef.current || detailsHoverRef.current)
      return null;
    const containerRect = containerRef.current.getBoundingClientRect();
    const canvasRect = canvasRef.current.getBoundingClientRect();
    let clonedEvent: any = {};
    clonedEvent.clientX = event.clientX + 0.5*(canvasRect.width - containerRect.width);
    clonedEvent.clientY = event.clientY + 0.5*(canvasRect.height - containerRect.height);
    
    const pickedObject = PlayCanvasHelper.GetPickedMesh(clonedEvent, cameraEntityRef.current.camera!);

    if(!pickedObject)
      return;
    if(showClickedMesh){ console.log(pickedObject.name); }

    if(pickedObject.name.toLocaleLowerCase().includes("property")){
      CheckProperty(pickedObject, event, true);
    }
  }


  const CheckProperty = (node: pc.GraphNode, event: PointerEvent, clicked: boolean = false) => {
    let propertyID: string = "";
    if(node.name.includes('@'))
      propertyID = PlayCanvasHelper.GetIDFromNodeName(node.name);
    if(!propertyID && node.parent && node.parent.name.includes('@'))
      propertyID = PlayCanvasHelper.GetIDFromNodeName(node.parent.name);
    if(!propertyID && node.parent?.parent && node.parent?.parent.name.includes('@'))
      propertyID = PlayCanvasHelper.GetIDFromNodeName(node.parent?.parent.name);
    if(!propertyID)
      return;
    
    const propertyData = propertyByIdRef.current[propertyID];
    if(!propertyData || !clicked)
      return;
    SelectProperty(propertyData, event.clientX, event.clientY, false)
  }

  const SelectProperty = (propertyData: any, screenX: number, screenY: number, convertCoords: boolean = true) => {
    if(!containerRef.current || !canvasRef.current)
      return;
    const containerRect = containerRef.current.getBoundingClientRect();
    const canvasRect = canvasRef.current.getBoundingClientRect();

    const convertedX = screenX - (convertCoords ? 0.5*(canvasRect.width - containerRect.width) : 0);
    const convertedY = screenY - (convertCoords ? 0.5*(canvasRect.height - containerRect.height) : 0);
    
    propertyData.verts=[];
    propertyData.verts[0]=[];
    propertyData.verts[0][0] = convertedX * originalWidth / window.innerWidth;
    propertyData.verts[0][1] = convertedY * originalHeight / window.innerHeight;
    setIsSelectedApto(propertyData);
  }

  React.useEffect(() => {
    SpinFrameChange(frame);
  }, [frame]);

  React.useEffect(() => {
    isPortraitRef.current = isPortrait;
  }, [isPortrait]);

  React.useEffect(() => {
    selectedAptoRef.current = isSelectedApto;
  }, [isSelectedApto]);

  React.useEffect(() => {
    UpdateAmenitiesVisibility();
    UpdateCamerasSpin();
    UpdateDetailsVisibility();
    UpdatePropertiesVisibility();
    UpdateTownPlanningVisibility();
    UpdateVolumeVisibility();
  }, [menuSelected]);

  React.useEffect(() => {
    UpdateTownPlanningVisibility();
    UpdateDetailsVisibility();
    UpdateCamerasSpin();
    UpdateVolumeVisibility();
  }, [subMenuSelected]);

  React.useEffect(() => {
    UpdateDetailsVisibility();
    UpdateCamerasSpin();
    UpdateVolumeVisibility();
  }, [hotspotsSelected]);

  React.useEffect(() => {
    UpdateTownPlanningVisibility();
  }, [isSelectedTownplanning]);

  React.useEffect(() => {
    UpdateAmenitiesVisibility()
  }, [isSelectedAmenities]);

  React.useEffect(() => {
    UpdateDetailsVisibility();
    UpdatePropertiesVisibility();
  }, [showTextHotspots]);

  React.useEffect(() => {
    UpdatePropertiesVisibility();
  }, [selectAvailability, isSelectedAttribute]);

  const setProgress = (frame: number) => {}

  const SpinFrameChange = (frame: number) => {
    if(!animComponentRef.current)
      return;

    for(const layer of animComponentRef.current.layers){
      const initFrameStr = PlayCanvasHelper.GetIDFromNodeName(layer.name);
      const initFrame = parseInt(initFrameStr);

      let animFrame = frame + initFrame;
      const animTime = animFrame / animFpsRef.current;

      layer.activeStateCurrentTime = animTime;
    }
  }

  const UpdateAmenitiesVisibility = (showActiveAmenity: boolean = true) => {
    if(!amenitiesRef.current)
      return;

    if(menuSelected !== "Amenidades"){ //se apagan todos los billboards
      for(const amenityBillboardKey in amenitiesRef.current.billboards){
        amenitiesRef.current.billboards[amenityBillboardKey].enabled = false;
      }
    }else{
      
      const showAllAmenities = isSelectedAmenities === "" ? true : false;
      for (const amenityID in amenitiesRef.current.billboards) {
        if(amenitiesRef.current.billboards[amenityID]){
          amenitiesRef.current.billboards[amenityID].enabled = showAllAmenities === true || (showActiveAmenity && amenityID === isSelectedAmenities);
        }
      }
    }
  }
  const UpdateCamerasSpin = () => {
    if(menuSelected === "Urbanismo"){
      cameraCurrentPositonRef.current = cameraPositonRef.current.townplanning;
      cameraCurrentTargetRef.current = cameraTargetRef.current.townplanning;
      if(cameraEntityRef.current)
        cameraEntityRef.current.camera!.fov = cameraFovRef.current.townplanning;
    }else if(menuSelected === "Amenidades"){
      cameraCurrentPositonRef.current = data.spin_amenities_active ? cameraPositonRef.current.amenities : cameraPositonRef.current.general;
      cameraCurrentTargetRef.current = data.spin_amenities_active ? cameraTargetRef.current.amenities : cameraTargetRef.current.general;
      if(cameraEntityRef.current)
        cameraEntityRef.current.camera!.fov = data.spin_amenities_active ? cameraFovRef.current.amenities : cameraFovRef.current.general;
    }else if(subMenuSelected === ""){
      cameraCurrentPositonRef.current = cameraPositonRef.current.general;
      cameraCurrentTargetRef.current = cameraTargetRef.current.general;
      if(cameraEntityRef.current)
        cameraEntityRef.current.camera!.fov = cameraFovRef.current.general;
    }else if(hotspotsSelected){//Detalle
      cameraCurrentPositonRef.current = cameraPositonRef.current[hotspotsSelected.hotspot_id];
      cameraCurrentTargetRef.current = cameraTargetRef.current[hotspotsSelected.hotspot_id];
      if(cameraEntityRef.current)
        cameraEntityRef.current.camera!.fov = cameraFovRef.current[hotspotsSelected.hotspot_id];
    }
  }
  const UpdateDetailsVisibility = () => {
    if(!detailsRef.current || !detailsStructRef.current)
      return;    

    if(detailsStructRef.current.h2_billboards === false){
      //original
      const showDetails = (menuSelected === "Inmuebles" || menuSelected === "") && subMenuSelected === "";
      for(const detailsID in detailsRef.current.billboards){
        detailsRef.current.billboards[detailsID].enabled = showDetails;
        detailsRef.current.texts[detailsID].enabled = showTextHotspots;
      }
    }else{
      //ocultos todos, para luego solo activar los que corresponda.
      for(const detailsID in detailsRef.current.billboards){
        detailsRef.current.billboards[detailsID].enabled = false;
        detailsRef.current.texts[detailsID].enabled = showTextHotspots;
      }
      if(!hotspotsSelected){
        const showDetails = (menuSelected === "Inmuebles" || menuSelected === "") && subMenuSelected === "";
        for(const h2Key in detailsStructRef.current.h2){
          const h2 = detailsStructRef.current.h2[h2Key];
          if(!h2)
            continue;
          if(!h2.billboard)
            continue;
          const hotspot_id = h2.billboard.hotspot_id;
          if(detailsRef.current.billboards[hotspot_id]){
            detailsRef.current.billboards[hotspot_id].enabled = showDetails;
            detailsRef.current.texts[hotspot_id].enabled = showTextHotspots;
          }
        }
      }else{
        const showDetails = (menuSelected === "Inmuebles");
        const group = detailsStructRef.current.hierarchical_groups_key_value[hotspotsSelected.hotspot_id]; //hotspotsSelected: no se usa porque le falta los Values
        if(!group)
          return;
        for(const hierarchical of group.hierarchicals){
          const h2 = detailsStructRef.current.h2[hierarchical.hierarchicals_id];
          if(!h2)
            continue;
          for(const valueKey in h2.values){
            const value = h2.values[valueKey];
            if(!value)
              continue;
            if(!value.billboard)
              continue;
            const hotspot_id = value.billboard.hotspot_id;
            if(detailsRef.current.billboards[hotspot_id]){
              detailsRef.current.billboards[hotspot_id].enabled = showDetails;
              detailsRef.current.texts[hotspot_id].enabled = showTextHotspots;
            }
          }
        }
      }
    }
  }
  const UpdatePropertiesVisibility = (showActiveProperty: boolean = true) => {
    if(!data || !propertiesRef.current)
      return;
    if(!propertiesRef.current.billboards || !propertiesRef.current.highlights) //if(!propertiesRef.current.billboards || !propertiesRef.current.highlights)
      return;

    const showProperties = (menuSelected === "Inmuebles");// && subMenuSelected === "";
    propertiesRef.current.root.enabled = showProperties;

    for(const property of data.properties.property){
      propertyByIdRef.current[property.id] = property;
      const isFiltered = showActiveProperty && showProperties && PlayCanvasHelper.FilterProperty(property, isSelectedAttribute, selectAvailability);
      
      const highlightProperty = propertiesRef.current.highlights[property.id]
      if(highlightProperty){ highlightProperty.enabled = isFiltered && showTextHotspots}
      
      const billboardProperty = propertiesRef.current.billboards[property.id]
      if(billboardProperty){ billboardProperty.enabled = isFiltered && showTextHotspots}
    }
  }
  const UpdateTownPlanningVisibility = () => {
    if(!townPlanningRef.current)
      return;
    //layouts
    for(const townPlaningKey in townPlanningRef.current.layouts){
      const enableChild = menuSelected === 'Urbanismo' && townPlaningKey === isSelectedTownplanning;
      const node = townPlanningRef.current.layouts[townPlaningKey];
      node.root.enabled = enableChild;
    }
    //billboards    
  }
  const UpdateVolumeVisibility = () => {
    if(!volumesRef.current || !detailsStructRef.current)
      return;

    if(subMenuSelected !== "" && hotspotsSelected){//vista de detalle
      //filtrar por volumen
      for(const volumeID in volumesRef.current.hierarchicals){
        volumesRef.current.hierarchicals[volumeID].enabled = false;
      }
      for(const hierarchical of hotspotsSelected.hierarchicals){
        //ORIGINAL
        const volumeID = hierarchical.hierarchicals_id;
        const node = volumesRef.current.hierarchicals[volumeID];
        if(node){node.enabled = true;}
        //EXTENDED
        const h2 = detailsStructRef.current.h2[volumeID];
        if(!h2)
          continue;
        for(const valueKey in h2.values){
          const node = volumesRef.current.hierarchicals[valueKey];
          if(node){node.enabled = true;}
        }
      }
    }else{
      //reactivar todos los volumes
      for(const volumeID in volumesRef.current.hierarchicals){
        volumesRef.current.hierarchicals[volumeID].enabled = true;
      }
    }

    for(const volumeMISC of volumesRef.current.miscs){
      const isGeneralSpin = menuSelected === "Urbanismo" || (subMenuSelected !== "" && hotspotsSelected)
      volumeMISC.enabled = !isGeneralSpin;
    }
    //se desactiva todos los volumenes en amenidades con spin de detalle...talves toque remover esto a futuro
    if(menuSelected === "Amenidades" && data.spin_amenities_active){
      for(const volumeID in volumesRef.current.hierarchicals){
        volumesRef.current.hierarchicals[volumeID].enabled = false;
      }
      for(const volumeMISC of volumesRef.current.miscs){
        volumeMISC.enabled = false;
      }

    }
  }

  const CreateScene = async () => {
    if(!canvasRef.current)
      return;

    PlayCanvasHelper.SetCanvas(canvasRef.current);

    const modelsURLs = { project: awsRootPath + data.models.project_glb }; //"./models/project.glb" || awsRootPath + data.models.project_glb
    const creationResults = await PlayCanvasHelper.CreateScene("spin", modelsURLs, setProgress, browserInfo, paramQuality, paramProfiler);

    const app = creationResults.app;
    appRef.current = creationResults.app;
    //showProfilerRef.current = creationResults.showProfiler;
    cameraEntityRef.current = creationResults.cameraEntity;
    billboardAssetsRef.current = creationResults.billboardAssets;
    rootEntityRef.current = creationResults.rootEntity;
    montserratMediumFontIDRef.current = creationResults.montserratMediumFontID;

    masterplanEntityRef.current = creationResults.masterplanEntity;
    animComponentRef.current = creationResults.animComponent;
    animFpsRef.current = creationResults.animFps;

    app.on('DetailsHover', DetailsHover);
    app.on('DetailsClicked', DetailsClicked);
    app.on('PropertyClicked', PropertyClicked);
    app.on('AmenityClicked', AmenityClicked);
    
    cameraEntityRef.current.camera!.fov = defaultFOV; //window.innerWidth < window.innerHeight ? cameraPortraitFOVRef.current : cameraLandscapeFOVRef.current;
    cameraEntityRef.current.camera!.horizontalFov = true;
    
    app.on('update', (dt) => { Update(dt) });
    
    await WaitForNextFrames(2); //para asegurar que se recalculen las matrices de los nodos ANTES de hacer cálculos.
    // app.root.syncHierarchy(); // alternativamente se puede hacer así.
    // app.update(0);

    if(masterplanEntityRef.current){
      for(const pluginLayer of masterplanEntityRef.current.children){
        const pluginLayerName = pluginLayer.name.toLocaleLowerCase();
        if (pluginLayerName.includes("amenities")) {
          SetupAmenities(pluginLayer);
          //pluginLayer.enabled = false;
        } else if (pluginLayerName.includes("cameras")) {
          SetupCameras(pluginLayer);
        } else if (pluginLayerName.includes("details")) {
          SetupDetails(pluginLayer);
        } else if (pluginLayerName.includes("properties")) {
          SetupProperties(pluginLayer);
        } else if (pluginLayerName.includes("townplanning")) {
          SetupTownPlanning(pluginLayer);
        } else if (pluginLayerName.includes("volume")) {
          SetupVolumes(pluginLayer);
        }
      }
    }
    //finalizada la carga y configuracion de los archivos
    SpinFrameChange(frame);
    setSceneReady(true);
  }

  const DetailsClicked = (id: string): void => {
    OnDetailsClicked(id);
  }

  const AmenityClicked = (id: string): void => {
    setIsSelectedAmenities(id)
  }

  const PropertyClicked = (event: any, propertyID: string): void => {
    const propertyData = propertyByIdRef.current[propertyID];
    if(!propertyData)
      return;
    SelectProperty(propertyData, event.x, event.y)
  }

  const DetailsHover = (isHovering: boolean): void => {
    detailsHoverRef.current = isHovering;
  }

  const SetupAmenities = (parentNode: pc.Entity|pc.GraphNode): void => {
    amenitiesRef.current = {};
    amenitiesRef.current.billboards = {};
    amenitiesRef.current.root = parentNode;
    amenitiesRef.current.root.enabled = true;

    for(const amenityNode of parentNode.children){
      amenityNode.enabled = true;
      const amenityID = PlayCanvasHelper.GetIDFromNodeName(amenityNode.name);
      AddAmenityBillboard(amenityNode, amenityID);
    }
  }

  const SetupCameras = (parentNode: pc.Entity|pc.GraphNode): void => {
    for(const cameraNode of parentNode.children){
      let cameraName = cameraNode.name.toLocaleLowerCase();
      if(cameraName.includes("general")) cameraName = "general";
      if(cameraName.includes("townplanning")) cameraName = "townplanning";
      if(cameraName.includes("amenities")) cameraName = "amenities";
      
      cameraFovRef.current[cameraName] = defaultFOV;
      for(const cameraChildNode of cameraNode.children){
        const cameraChildNodeName = cameraChildNode.name.toLocaleLowerCase();
        if(cameraChildNodeName.includes("positionanim")){
          cameraPositonRef.current[cameraName] = cameraChildNode;
          for(const firstCameraChildNode of cameraChildNode.children){
            cameraPositonRef.current[cameraName] = firstCameraChildNode;
          }
        }else if(cameraChildNodeName.includes("targetanim")){
          cameraTargetRef.current[cameraName] = cameraChildNode;
          for(const firstCameraChildNode of cameraChildNode.children){
            cameraTargetRef.current[cameraName] = firstCameraChildNode;
          }
        }else if(cameraChildNodeName.includes("fov")){
          let fov = cameraChildNode.getLocalScale().x;
          for(const firstCameraChildNode of cameraChildNode.children){
            fov = firstCameraChildNode.getLocalScale().x;
          }
          cameraFovRef.current[cameraName] = fov;
        }
      }
    }
    cameraCurrentPositonRef.current = cameraPositonRef.current.general;
    cameraCurrentTargetRef.current = cameraTargetRef.current.general;
    cameraEntityRef.current!.camera!.fov = cameraFovRef.current.general;
  }

  const SetupDetails = (parentNode: pc.Entity|pc.GraphNode): void => {
    
    detailsRef.current = {};
    detailsRef.current.billboards = {};
    detailsRef.current.texts = {};
    detailsRef.current.hierarchicals = {};
    detailsRef.current.root = parentNode;
    detailsRef.current.root.enabled = true;

    const color = new pc.Color().fromString(data.colors.main_buttons.trim());
    detailsStructRef.current = PlayCanvasHelper.CreateHierarchicalStructs(data);////////////

    for(const detailsNode of parentNode.children){
      const detailsID = PlayCanvasHelper.GetIDFromNodeName(detailsNode.name);
      const hierarchical_group = detailsStructRef.current.hierarchical_groups_key_value[detailsID];
      if(hierarchical_group.detailed_view === 1){
        for(const hierarchical of hierarchical_group.hierarchicals){
          const hierarchical_id = hierarchical.hierarchicals_id;
          const h2 = detailsStructRef.current.h2[hierarchical_id];
          if(h2){
            detailsStructRef.current.h2_billboards = true;
          }
        }
      }
      const currentHotspots: any = data?.hierarchical_groups?.find((e: any) => e.hotspot_id === detailsID);
      const isClickeable: boolean = currentHotspots.detailed_view === 1;
      const detailsName = currentHotspots ? currentHotspots.hotspot_name : "Error";
      cameraFovRef.current[detailsID] = defaultFOV;
      
      for(const billboardCamHierarchicalNode of detailsNode.children){
        const billboardCamHierarchicalNodeName = billboardCamHierarchicalNode.name.toLocaleLowerCase();
        if(billboardCamHierarchicalNodeName.includes("billboard")){
          const billboard = new pc.Entity("billboardProp@"+detailsID);
          billboard.addComponent('script');
          const textMesh = PlayCanvasHelper.CreateCapsuleBillboardTextNode(billboardAssetsRef.current, billboard, detailsID, montserratMediumFontIDRef.current, detailsName, new pc.Color(1,1,1), color, 800, true, isClickeable);
          billboard.script?.["billboardCapsuleScalerAndLookAt"].ChangeLookAtEntity(cameraEntityRef.current);
          billboard.script?.["billboardCapsuleScalerAndLookAt"].SetPortraitRef(isPortraitRef);
          billboard.addChild(textMesh);
          billboardCamHierarchicalNode.addChild(billboard);
          detailsRef.current.billboards[detailsID] = billboard;
          detailsRef.current.texts[detailsID] = textMesh.children[1];
        }else if(billboardCamHierarchicalNodeName.includes("positionanim")){
          cameraPositonRef.current[detailsID] = billboardCamHierarchicalNode;
          for(const cameraChildNode of billboardCamHierarchicalNode.children){
            cameraPositonRef.current[detailsID] = cameraChildNode;
          }
        }else if(billboardCamHierarchicalNodeName.includes("targetanim")){
          cameraTargetRef.current[detailsID] = billboardCamHierarchicalNode;
          for(const cameraChildNode of billboardCamHierarchicalNode.children){
            cameraTargetRef.current[detailsID] = cameraChildNode;
          }
        }else if(billboardCamHierarchicalNodeName.includes("fov")){
          let fov = billboardCamHierarchicalNode.getLocalScale().x;
          for(const cameraChildNode of billboardCamHierarchicalNode.children){
            fov = cameraChildNode.getLocalScale().x;
          }
          cameraFovRef.current[detailsID] = fov;
        }else if(billboardCamHierarchicalNodeName.includes("hierarchicals")){
          const hierarchicals: any[] = [];
          for(const hierarchicalNode of billboardCamHierarchicalNode.children){
            const hierarchicalID = PlayCanvasHelper.GetIDFromNodeName(hierarchicalNode.name);
            hierarchicals.push(hierarchicalID);
          }
          detailsRef.current.hierarchicals[detailsID] = hierarchicals;
        }
      }
    }
    UpdateDetailsVisibility();
  }

  const SetupProperties = (parentNode: pc.Entity|pc.GraphNode): void => {
    
    propertiesRef.current = {};
    propertiesRef.current.views = {};
    propertiesRef.current.highlights = {};
    propertiesRef.current.billboards = {};
    propertiesRef.current.root = parentNode;
    propertiesRef.current.root.enabled = false;

    const color = PlayCanvasHelper.GetRGBFromHexString(data.colors.secondary_text);
    const textColorString = `rgb(${color.r}, ${color.g}, ${color.b})`;
    const textFillString = `rgba(${color.r}, ${color.g}, ${color.b}, 0.01)`;
    const colorMaterials: any = {};
    //const propertyBorderMaterial = PlayCanvasHelper.CreateLayoutMaterialFromColor("white", new pc.Color(1,1,1), false, 1.0);

    const hierarchicalLevel = PlayCanvasHelper.GetIDFromNodeName(propertiesRef.current.root.name).toLocaleLowerCase();
    //Nota: se podría hacer recursivamente el recorrido de las jerarquías.
    //Sin embargo prefiero así para que sea fácil de entender lo que se está haciendo.
    if(hierarchicalLevel.includes('h1')){
      for(const level1 of parentNode.children){
        const level1ID = PlayCanvasHelper.GetIDFromNodeName(level1.name);
        for(const floor of level1.children){
          const floorID = PlayCanvasHelper.GetIDFromNodeName(floor.name);
          if(floorID === level1ID){ //SÍ es un nodo de piso
            for(const aptoNode of floor.children){
              const aptoID = PlayCanvasHelper.GetIDFromNodeName(aptoNode.name);
              propertiesRef.current.highlights[aptoID] = aptoNode;
            }
          }else{//no es un piso, es un apto
            propertiesRef.current.highlights[floorID] = floor;
          }
        }
      }
    }
    if(hierarchicalLevel.includes('h2')){
      for(const level2 of parentNode.children){
        for(const level1 of level2.children){
          const level1ID = PlayCanvasHelper.GetIDFromNodeName(level1.name);
          for(const floor of level1.children){
            const floorID = PlayCanvasHelper.GetIDFromNodeName(floor.name);
            if(floorID === level1ID){ //SÍ es un nodo de piso
              for(const aptoNode of floor.children){
                const aptoID = PlayCanvasHelper.GetIDFromNodeName(aptoNode.name);
                propertiesRef.current.highlights[aptoID] = aptoNode;
              }
            }else{//no es un piso, es un apto
              propertiesRef.current.highlights[floorID] = floor;
            }
          }
        }
      }
    }

    let towers: any = "";
    for (const attribute of data.properties.attributes){//es solo para extraer el color
      if(attribute.type === "Hierarchical" && attribute.hierarchicalLevel === 'Jerarquico #1'){
        towers = attribute.values;
        break;
      }
    }

    for (const propertyData of data.properties.property) {
      const propertyID = propertyData.id;
      const propertyName = propertyData.property;
      const propertyNode = propertiesRef.current.highlights[propertyData.id]
      
      if (propertyNode){
        let colorHex: any = '#000000';
        if(data.properties.disponibilidad === true){//prioridad Disponibilidad
          colorHex = PlayCanvasHelper.GetAptoColorByAvailability(propertyData.availability)
        }else{
          let attributesType: any = null;
          for (const attribute of data.properties.attributes){//segundo Tipología
            if(attribute.type === "Tipologia" || attribute.name === "Apto tipo" || attribute.name === "Casas tipo"){
              attributesType = attribute.values;
              break;
            }
          }
          if(!attributesType){ //último el jerárquico 1
            let hierarchical_id = "";
            for (const attribute of propertyData.values){
              if(attribute.type === 'Hierarchical' && attribute.hierarchicalLevel === 'Jerarquico #1'){
                hierarchical_id = attribute.IdValue;
              }
            }
            if(hierarchical_id && towers){
              for(const tower of towers){
                if(tower.id === hierarchical_id){
                  colorHex = tower.layoutFill;
                }
              }
            }
          }else{
            colorHex = PlayCanvasHelper.GetAptoColorByType(propertyData, attributesType)
          }
        }
        
        if(!colorMaterials[colorHex]){
          const bgColor = new pc.Color();
          colorMaterials[colorHex] = {
            bgColor: bgColor.fromString(colorHex),
            materialBorder: PlayCanvasHelper.CreateLayoutMaterialFromColor("borderMat@"+propertyID, bgColor, true, browserInfo.isBrowserSafari === true ? defaultSafariLayoutBorderOpacity : defaultLayoutBorderOpacity),
            //materialBorder: propertyBorderMaterial,
            materialLayout:PlayCanvasHelper.CreateLayoutMaterialFromColor("layoutMat@"+propertyID, bgColor, true, browserInfo.isBrowserSafari === true ? defaultSafariLayoutOpacity : defaultLayoutOpacity),
          }
        }
        const bgColor = colorMaterials[colorHex].bgColor;
        const materialBorder = colorMaterials[colorHex].materialBorder;
        const materialLayout = colorMaterials[colorHex].materialLayout;

        for (const layoutOrBillboard of propertyNode.children) {//hijos del inmueble
          const layoutOrBillboardName = layoutOrBillboard.name.toLocaleLowerCase();
          if(layoutOrBillboardName.includes("billboard")){
            AddPropertyBillboard(layoutOrBillboard, propertyName, propertyID, bgColor, textColorString, textFillString);
          }
          if(layoutOrBillboardName.includes("layoutshape")){
            AddPropertyLayouts(layoutOrBillboard, propertyID, bgColor, materialBorder, materialLayout);
          }
        }
      }
    }
  }

  const SetupTownPlanning = (parentNode: pc.Entity|pc.GraphNode): void => {
    townPlanningRef.current = {};
    townPlanningRef.current.views = {};
    townPlanningRef.current.layouts = {};
    townPlanningRef.current.root = parentNode;
    townPlanningRef.current.enabled = true;//false

    for(const hierarchicalNode of parentNode.children){
      hierarchicalNode.enabled = false;
      const hierarchicalNodeName = hierarchicalNode.name.toLocaleLowerCase();//Hierarchical1/torres) | Hierarchical2/etapas)
      
      for(const elementsMesh of hierarchicalNode.children){//torre 1, torre 2, torre 3 | etapa 1, etapa 2, etapa 3

        elementsMesh.enabled = true;
        const elementID = PlayCanvasHelper.GetIDFromNodeName(elementsMesh.name);
        let elementName = "";
        let hierarchicalName = "";
        const color = new pc.Color().fromString(data.colors.main_buttons.trim());

        for (const attribute of data.properties.attributes){
          if( (hierarchicalNodeName === "hierarchical1" && attribute.hierarchicalLevel === 'Jerarquico #1') || (hierarchicalNodeName === "hierarchical2" && attribute.hierarchicalLevel === 'Jerarquico #2')){
            hierarchicalName = attribute.name;
            for (const element of attribute.values){
              if(element.id === elementID){
                color.fromString(element.layoutFill);
                elementName = element.value;
                break;
              }
            }
            break;
          }
        }

        if(!townPlanningRef.current.layouts[hierarchicalName]){
          townPlanningRef.current.layouts[hierarchicalName] = {
            root: hierarchicalNode, //Hierarchical1 (torres) | Hierarchical2 (etapas)
            nodes: [],
          }
        }
        townPlanningRef.current.layouts[hierarchicalName].nodes.push(elementsMesh);

        for (const layoutNode of elementsMesh.children) {
          const layoutNodeName = layoutNode.name.toLocaleLowerCase();
          if(layoutNodeName.includes("layout")){
            AddTownPlanningLayouts(layoutNode, elementID, color);
          }else if(layoutNodeName.includes("billboard")){
            AddTownPlanningBillboard(layoutNode, elementID, elementName, color);
          }
        }

      }
    }
  }

  const SetupVolumes = (parentNode: pc.GraphNode): void => {
    volumesRef.current = {};
    volumesRef.current.hierarchicals = {};
    volumesRef.current.miscs = [];
    volumesRef.current.root = parentNode;
    volumesRef.current.root.enabled = true;//true
    PlayCanvasHelper.EnablePickRecursive(parentNode, true);

    const fakeOcclusionMat = new pc.StandardMaterial();
    fakeOcclusionMat.depthWrite = true;  // Escribe en Z-buffer
    fakeOcclusionMat.depthTest = true;
    fakeOcclusionMat.blendType = pc.BLEND_NONE;
    fakeOcclusionMat.redWrite = false;
    fakeOcclusionMat.greenWrite = false;
    fakeOcclusionMat.blueWrite = false;
    fakeOcclusionMat.alphaWrite = false;
    fakeOcclusionMat.update();

    for(const volumeNode of parentNode.children){
      const hierarchicalID = PlayCanvasHelper.GetIDFromNodeName(volumeNode.name);
      for(const layoutNode of volumeNode.children){
        const layoutNodeName = layoutNode.name.toLocaleLowerCase();
        if(layoutNodeName.includes("freeshape")){
          if(!volumeNode.name.toLocaleLowerCase().includes("misc"))
            volumesRef.current.hierarchicals[hierarchicalID] = layoutNode;
          else
            volumesRef.current.miscs.push(layoutNode)
          for(const meshNode of layoutNode.children){
            PlayCanvasHelper.SetNodeMaterial(meshNode, fakeOcclusionMat);
          }
        }
      }
    }
  }

  const AddAmenityBillboard = async (node: pc.GraphNode, amenityID: string) => {
    if(!appRef.current || !billboardAssetsRef.current)
      return;

    let startPointNode: pc.GraphNode|null = null;
    let endPointNode: pc.GraphNode|null = null;
    for(const point of node.children){
      const pointName = point.name.toLocaleLowerCase();
      if(pointName.includes('startpoint'))
        startPointNode = point;
      if(pointName.includes('endpoint')){
        endPointNode = point;
      }
    }

    let iconURL: string|null = null
    for(const amenityData of data.amenities.menu){
      if(amenityData.id === amenityID){
        iconURL = awsRootPath + amenityData.icon.replace(".svg",".png");
      }
    }

    if(!startPointNode || !endPointNode || !iconURL)
      return;

    const billboardParent = new pc.Entity("billboardParent@"+amenityID);
    billboardParent.addComponent('script');
    billboardParent.setLocalPosition( startPointNode.getPosition().clone() );
    appRef.current.root.addChild(billboardParent);

    PlayCanvasHelper.CreateAmenityBillboard(data, billboardAssetsRef.current, cameraEntityRef.current, isPortraitRef, billboardParent, amenityID, endPointNode, iconURL);
    billboardParent.enabled = false;
    amenitiesRef.current.billboards[amenityID] = billboardParent;
  }

  const AddPropertyBillboard = async (endPointNode: pc.GraphNode, propertyName: string, propertyID: string, bgColor: pc.Color, textColorString: string, textFillString: string) => {
    if(!billboardAssetsRef.current.propertyTexture || !appRef.current)
      return;

    const billboardEnd = new pc.Entity("propertyBB@"+propertyID);
    appRef.current.root.addChild(billboardEnd);
    billboardEnd.setPosition(endPointNode.getPosition().clone());
    billboardEnd.addComponent('script');

    const textMesh = CreatePropertyBillboard(billboardEnd, propertyID, propertyName, "property", new pc.Color(1,1,1), bgColor);
    billboardEnd.addChild(textMesh!);
    
    billboardEnd.enabled = false;
    propertiesRef.current.billboards[propertyID] = billboardEnd;
  }

  const AddPropertyLayouts = async (layoutNode: pc.Entity, propertyID: string, bgColor: pc.Color, materialBorder: pc.Material, materialLayout: pc.Material) => {
    
    let childNumber = 0;
    for (const childNode of layoutNode.children) {
      let material: pc.Material | null = null;
      if(childNode.name.toLowerCase().includes("lattice")){
        childNode.name = `propertyl${childNumber}@${propertyID}`;
        material = materialBorder;
      }
      if(childNode.name.toLowerCase().includes("shape")){
        childNode.name = `propertys${childNumber}@${propertyID}`;
        material = materialLayout;
      }
      if(material){
        PlayCanvasHelper.SetNodeMaterial(childNode, material);
      }
      childNumber = childNumber + 1;
    }

    const hslColor = PlayCanvasHelper.Rgb2Hsl(bgColor);
    const selectedColor = PlayCanvasHelper.Hsl2Rgb(hslColor.h, hslColor.s, 1);
    layoutNode.addComponent('script');
    layoutNode.script?.create('propertyBehavior', {
      attributes: {
        propertyID: propertyID,
      }
    });
    layoutNode.script?.["propertyBehavior"].SetRefs(isPortraitRef, selectedAptoRef);
    layoutNode.script?.["propertyBehavior"].SetAnimationColors(bgColor, selectedColor);
    layoutNode.script?.["propertyBehavior"].SetAnimationMaterials(materialBorder, materialLayout);

    propertiesRef.current.highlights[propertyID] = layoutNode;
  }

  const AddTownPlanningBillboard = async (endPointNode: pc.GraphNode, townPlanningID: string, townPlanningName: string, color: pc.Color) => {
    const billboard = new pc.Entity(townPlanningName+"_TP@"+townPlanningID);
    billboard.addComponent('script');
    endPointNode.addChild(billboard);
    const textMesh = PlayCanvasHelper.CreateCapsuleBillboardTextNode(billboardAssetsRef.current, billboard, townPlanningID, montserratMediumFontIDRef.current, townPlanningName, new pc.Color(1,1,1), color, 800, false, false);
    billboard.script?.["billboardCapsuleScalerAndLookAt"].ChangeLookAtEntity(cameraEntityRef.current);
    billboard.addChild(textMesh);
  }

  const AddTownPlanningLayouts = async (layoutNode: pc.GraphNode, townPlanningID: string, color: pc.Color) => {
    const materialBorder = PlayCanvasHelper.CreateLayoutMaterialFromColor("borderMat@allamenities", color, true, browserInfo.isBrowserSafari === true ? defaultSafariLayoutBorderOpacity : defaultLayoutBorderOpacity);
    const materialLayout = PlayCanvasHelper.CreateLayoutMaterialFromColor("layoutMat@allamenities", color, true, browserInfo.isBrowserSafari === true ? defaultSafariLayoutOpacity : defaultLayoutOpacity);

    let childNumber = 0;
    for (const childNode of layoutNode.children) {
      let material: pc.Material | null = null;
      if(childNode.name.toLowerCase().includes("lattice")){
        childNode.name = `tp_l${childNumber}@${townPlanningID}`;
        material = materialBorder;
      }
      if(childNode.name.toLowerCase().includes("shape")){
        childNode.name = `tp_s${childNumber}@${townPlanningID}`;
        material = materialLayout;
      }
      if(material){
        PlayCanvasHelper.SetNodeMaterial(childNode, material);
      }
      childNumber = childNumber + 1;
    }
  }

  const CreatePropertyBillboard = (billboardEnd: pc.Entity, propertyID: string, texto: string, prefix: string, textColor: pc.Color, colorFill: pc.Color) : pc.Entity|null => {
    if(!appRef.current || !billboardAssetsRef.current)
      return null;
    
    const worldScreen = new pc.Entity("WorldScreen"+texto);
    worldScreen.addComponent("screen", {
      screenSpace: false,
      resolution: pc.Vec2.ONE,
      referenceResolution: new pc.Vec2(1280, 720),
      //scaleMode: "blend",
    });
    worldScreen.setLocalEulerAngles(0, 180, 0);
    worldScreen.setLocalScale(0.0075, 0.0075, 0.0075);///escala global de properties billboard, default 0.01

    const background = new pc.Entity(prefix+"BG"+texto);
    background.addComponent("element", {
      type: pc.ELEMENTTYPE_IMAGE,
      texture: billboardAssetsRef.current.propertyTexture,
      pivot: new pc.Vec2(0.5, 0.5),
      anchor: new pc.Vec4(0.5, 0.5, 0.5, 0.5),
      color: colorFill,
      width: 1000,
      height: 1000,
      useInput: true,
    });
    background.element!.layers = [pc.LAYERID_WORLD];
    worldScreen.addChild(background);

    const text = new pc.Entity(prefix+"_"+texto);
    text.addComponent("element", {
      type: pc.ELEMENTTYPE_TEXT,
      fontAsset: montserratMediumFontIDRef.current,
      text: ` ${texto} `,
      pivot: new pc.Vec2(0.5, 0.5),
      anchor: new pc.Vec4(0, 0, 1, 1),
      margin: new pc.Vec4(0, 0, 0, 0),
      autoWidth: false,
      autoHeight: false,
      autoFitWidth: true,
      autoFitHeight: true,
      minFontSize: 100,
      maxFontSize: 1000,
      color: textColor,
    });
    text.element!.layers = [pc.LAYERID_WORLD];
    background.addChild(text);
    const localText = text.getLocalPosition();
    text.setLocalPosition(localText.x, localText.y, 100); //corrimiento para que quede al frente

    const hslColor = PlayCanvasHelper.Rgb2Hsl(colorFill);
    const selectedColor = PlayCanvasHelper.Hsl2Rgb(hslColor.h, hslColor.s, 1);

    billboardEnd.script?.create('propertyBehavior', {
      attributes: {
        propertyID: propertyID,
        endEntity: billboardEnd,
        scaleReduction: 500,
        lookAtEntity: cameraEntityRef.current,
        freeRotation: true,

        bgBillboardEntity: background,
        textBillboardEntity: text,
      }
    });
    billboardEnd.script?.["propertyBehavior"].SetRefs(isPortraitRef, selectedAptoRef);
    billboardEnd.script?.["propertyBehavior"].SetAnimationColors(colorFill, selectedColor);
    return worldScreen;
  }

  const WaitForNextFrames = async (minFrameWait: number = 1) : Promise<void>  => {
    return new Promise((resolve, reject) => {
      const currentFrame = frameCountRef.current;
      const intervalID = setInterval(() => {
        if(frameCountRef.current >  currentFrame + minFrameWait - 1){
          clearInterval(intervalID);
          resolve();
        }
      }, 10);
    })
  }

  const Update = (deltaTime: number): void => {
    frameCountRef.current = frameCountRef.current + 1;
    if(!cameraCurrentPositonRef.current || !cameraCurrentTargetRef.current || !cameraEntityRef.current)
      return;

    cameraEntityRef.current.setPosition(cameraCurrentPositonRef.current.getPosition().clone());
    cameraEntityRef.current.lookAt(cameraCurrentTargetRef.current.getPosition().clone());
    //console.log(cameraEntityRef.current.camera!.fov);
    if(showCameraPosition) console.log("camera:", cameraEntityRef.current.getPosition());
  }

  return (
    <div ref={containerRef} className={`model-container ${isPortrait ? "portrait" : ""} ${isVisible ? "visible" : ""} ${isSelectedAptoView !== null ? "notransition" : ""}`}>
      <canvas ref={canvasRef} className={`${isPortrait ? "model-canvas-portrait" : "model-canvas-landscape"} ${isConstantWidth ? "model-canvas-constant-width" : "model-canvas-constant-height"}`}/>
      {showCurrentFrame && <div className={`model-container-frame-container`}>{`Frame: ${(frame+1)}`}</div>}
    </div>
  );

}

export default SpinsEngine;